module.exports = __webpack_public_path__ + "img/zombie.4840fe9f.webp";